import enLocale from 'element-ui/lib/locale/lang/en';
const en = {
  message: {
    hello: 'hello world'
  },
  ...enLocale
}

export default en


// WEBPACK FOOTER //
// ./src/components/common/langs/en.js